var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.2148,
    r: 24,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2583 28.0807V30.2956C16.2583 31.2131 17.001 31.9568 17.9173 31.9568H30.0832C30.9995 31.9568 31.7422 31.2131 31.7422 30.2956V28.0807C31.7422 27.775 31.4944 27.5269 31.1892 27.5269C30.8839 27.5269 30.6362 27.775 30.6362 28.0807V30.2956C30.6362 30.6012 30.3884 30.8493 30.0832 30.8493H17.9173C17.612 30.8493 17.3643 30.6012 17.3643 30.2956V28.0807C17.3643 27.775 17.1166 27.5269 16.8113 27.5269C16.506 27.5269 16.2583 27.775 16.2583 28.0807ZM23.4472 17.9259V27.5269C23.4472 27.8326 23.695 28.0807 24.0002 28.0807C24.3055 28.0807 24.5532 27.8326 24.5532 27.5269V17.9259L27.4548 21.247C27.656 21.4769 28.0056 21.5001 28.2356 21.299C28.4652 21.0976 28.4884 20.7475 28.2875 20.5173C28.2875 20.5173 26.3864 18.3422 25.2489 17.0405C24.9337 16.6799 24.4785 16.4729 24.0002 16.4729C23.5219 16.4729 23.0668 16.6799 22.7515 17.0405L19.7129 20.5173C19.5121 20.7475 19.5353 21.0976 19.7649 21.299C19.9948 21.5001 20.3444 21.4769 20.5456 21.247L23.4472 17.9259Z",
    fill: "#6C9DF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.e939fa13.svg";
export { ForwardRef as ReactComponent };